<h2 mat-dialog-title>Generar Agenda</h2>
<mat-dialog-content>
  <form #form class="example-form">
    <h4>Ordenar por:</h4>
    <!-- algoritmo -->
    <mat-form-field appearance="fill">
      <mat-label>Algoritmo</mat-label>
      <mat-select [(ngModel)]="selectedValue" name="algoritmo" required>
        <mat-option
          *ngFor="let algoritmo of algoritmos"
          [value]="algoritmo.value"
        >
          {{ algoritmo.viewValue }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="algoritmo.hasError('required')">Debe elegir un <strong>Algoritmo</strong></mat-error>
    </mat-form-field>
    <!-- sesiones -->
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Cantidad de Sesiones <strong>(número)</strong></mat-label>
      <input
        matInput
        [formControl]="sesiones"
        [errorStateMatcher]="matcher"
        type="number"
        maxlength="2"
        min="1"
        onkeydown="javascript: return event.keyCode === 8 ||
      event.keyCode === 46 ? true : !isNaN(Number(event.key))"
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
        required
      />
      <mat-error *ngIf="sesiones.hasError('required')"
        >Número <strong>requerido</strong></mat-error
      >
    </mat-form-field>
    <!-- tracks -->
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Cantidad de Tracks <strong>(número)</strong></mat-label>
      <input
        matInput
        [formControl]="tracks"
        [errorStateMatcher]="matcher"
        type="number"
        maxlength="2"
        min="1"
        onkeydown="javascript: return event.keyCode === 8 ||
        event.keyCode === 46 ? true : !isNaN(Number(event.key))"
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
        required
      />
      <mat-error *ngIf="tracks.hasError('required')"
        >Número <strong>requerido</strong></mat-error
      >
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
      mat-raised-button color="primary"
      [disabled]="!formGroup.valid || !formGroup.dirty"
      (click)="onSubmit()"
  >
    Generar
  </button>
  <button mat-button color="primary" (click)="onClose()">Cancelar</button>
</mat-dialog-actions>
